import script from "./GlobalOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GlobalOverlay.vue?vue&type=style&index=0&id=48efa63e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48efa63e"]])

export default __exports__